//create CRUD class with axios
import axios, { AxiosResponse } from "axios";
import fileDownload from "js-file-download";
import DataService from "./dataservice.base";

type ReportParams = {
  type: String;
  format: String;
  startDate: String;
  endDate?: String;
  storeId: String;
  storeName?: String;
  timestamp: string;
  showOnlyMove?: boolean;
};

export default class ReportsDataService extends DataService {
  // resolve ตอนใช้จริง ไม่ใช่ตอน new — instance ถูกสร้างตั้งแต่ import โมดูล
  // ซึ่งบางจังหวะ runtimeConfig ยังไม่พร้อม (เหตุผลเดียวกับ apiUrl ใน base)
  protected get URL(): string {
    return `${useBaseUrl("report")}/reports`;
  }

  constructor(path: string) {
    super(path);
  }

  async getReport(params: ReportParams): Promise<AxiosResponse> {
    return await axios.post(this.URL, params);
  }

  async changePassword(params:any){
    return await axios.post(this.URL, params);
  }

  async downloadReport(params: ReportParams, queryString: string =""): Promise<any> {
    try {
      const response = await axios.post(`${this.URL}${queryString}`, params, {
        responseType: "arraybuffer",
      });

      if (response) {
        const filename = response.headers
          ? response.headers?.get("Content-Disposition")?.split("=")[1]
          : undefined;

        fileDownload(response.data, filename);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async downloadPdfReport(params: ReportParams): Promise<any> {
    try {
      const response = await axios.post(this.URL, params, {
        responseType: "arraybuffer",
      });

      if (response) {
        const filename = getPdfFilename(response.headers?.get("Content-Disposition"));

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log(error);
    }
  }
}

function getPdfFilename(input) {
  const regex = /filename="([^"]+)"/;
  const match = input.match(regex);
  return match ? match[1] : "download.pdf";
}

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { ReportsDataService };
